import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  booleanAttribute,
  numberAttribute,
  signal,
} from '@angular/core';

function stringToIcon(value: string | Icon): Icon {
  if (typeof value === 'string') {
    return value as Icon;
  }

  return value;
}

@Component({
  selector: 'vti-icons',
  templateUrl: './icons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class IconsComponent implements OnInit {
  @Input({ required: true, transform: stringToIcon }) public icon!: Icon;
  @Input() public color = 'white';
  @Input() public colorTint: string | undefined;
  @Input({ transform: numberAttribute }) public size = 4;
  @Input({ transform: booleanAttribute }) public filled = false;

  public ngOnInit(): void {
    this.classes.update(() => `h-${this.size} w-${this.size} text-${this.color}`);

    if (this.colorTint) {
      this.classes.update((classes) => `${classes}-${this.colorTint}`);
    }
  }

  public classes = signal<string>('');
}

export type Icon =
  | 'save'
  | 'cancel'
  | 'question'
  | 'loading'
  | 'error'
  | 'warning'
  | 'info'
  | 'logout'
  | 'back'
  | 'home'
  | 'arrow-left'
  | 'arrow-right'
  | 'bell'
  | 'bell-filled'
  | 'dot'
  | 'burger'
  | 'x'
  | 'map'
  | 'tab'
  | 'spinner'
  | 'twitter'
  | 'facebook'
  | 'linkedin'
  | 'biometric'
  | 'add-file';
